<div *ngIf="deviceParamGatewayV3Server">

  <div class="edit-container-params" *ngIf="editable">
    <h4>{{'SERVER'|translate}}</h4>
    <form [formGroup]="serverForm">

      <mat-slide-toggle formControlName="use_ssl" (change)="setDeviceWithForm()">{{'USE_SSL'|translate}}
      </mat-slide-toggle>

      <br/>
      <mat-form-field>
        <mat-label>{{'GW_FIRMWARE'|translate}} :</mat-label>
        <input matInput placeholder="Url" formControlName="gw_firmware_url" type="text"
               (keyup)="setDeviceWithForm()">
      </mat-form-field>
      <br/>
      <mat-form-field>
        <mat-label>{{'GW_FIRMWARE_VERSION'|translate}} :</mat-label>
        <input matInput placeholder="Version" formControlName="gw_firmware_version" type="text"
               (keyup)="setDeviceWithForm()">
      </mat-form-field>
      <br/>
      <mat-form-field>
        <mat-label>{{'LIRIS_FIRMWARE'|translate}} :</mat-label>
        <input matInput placeholder="Url" formControlName="liris_firmware_url" type="text"
               (keyup)="setDeviceWithForm()">
      </mat-form-field>
      <mat-form-field>
        <br/>
        <mat-label>{{'LIRIS_FIRMWARE_VERSION'|translate}} :</mat-label>
        <input matInput placeholder="Version" formControlName="liris_firmware_version" type="text"
               (keyup)="setDeviceWithForm()">
      </mat-form-field>
      <br/>
      <mat-form-field>
        <mat-label>{{'CONFIG'|translate}} :</mat-label>
        <input matInput placeholder="Url" formControlName="config" type="text"
               (keyup)="setDeviceWithForm()">
      </mat-form-field>
      <br/>
      <mat-form-field>
        <mat-label>{{'DATA'|translate}} :</mat-label>
        <input matInput placeholder="Url" formControlName="data" type="text"
               (keyup)="setDeviceWithForm()">
      </mat-form-field>
    </form>
  </div>

  <div *ngIf="!editable" class="read-container-params">
    <h4>{{'SERVER'|translate}}</h4>

    <mat-slide-toggle [ngModel]="deviceParamGatewayV3Server.use_ssl" [disabled]="true">{{'USE_SSL'|translate}}
    </mat-slide-toggle>

    <br/>
    <mat-form-field>
      <mat-label>{{'GW_FIRMWARE'|translate}} :</mat-label>
      <input matInput placeholder="Url" [value]="deviceParamGatewayV3Server.gw_firmware.url" [readonly]="true">
    </mat-form-field>
    <br/>
    <mat-form-field>
      <mat-label>{{'GW_FIRMWARE_VERSION'|translate}} :</mat-label>
      <input matInput placeholder="Version" [value]="deviceParamGatewayV3Server.gw_firmware.version" [readonly]="true">
    </mat-form-field>
    <br/>
    <mat-form-field>
      <mat-label>{{'LIRIS_FIRMWARE'|translate}} :</mat-label>
      <input matInput placeholder="Url" [value]="deviceParamGatewayV3Server.liris_firmware.url" [readonly]="true">
    </mat-form-field>
    <br/>
    <mat-form-field>
      <mat-label>{{'LIRIS_FIRMWARE_VERSION'|translate}} :</mat-label>
      <input matInput placeholder="Version" [value]="deviceParamGatewayV3Server.liris_firmware.version" [readonly]="true">
    </mat-form-field>
    <br/>
    <mat-form-field>
      <mat-label>{{'CONFIG'|translate}} :</mat-label>
      <input matInput placeholder="Url" [value]="deviceParamGatewayV3Server.config" [readonly]="true">
    </mat-form-field>
    <br/>
    <mat-form-field>
      <mat-label>{{'DATA'|translate}} :</mat-label>
      <input matInput placeholder="Url" [value]="deviceParamGatewayV3Server.data" [readonly]="true">
    </mat-form-field>

  </div>

</div>
